package chand.wordvoyage.platform

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

private fun jsSpeakText(text: String) {
    js("""
        if (window.speechSynthesis) {
            window.speechSynthesis.cancel();
            var utterance = new SpeechSynthesisUtterance(text);
            window.speechSynthesis.speak(utterance);
        }
    """)
}

@Composable
actual fun rememberTextToSpeech(): TextToSpeechEngine = remember {
    object : TextToSpeechEngine {
        override fun speak(text: String) = jsSpeakText(text)
        override fun dispose() {}
    }
}

